module.exports = __webpack_public_path__ + "static/vzEye_eyeFrame-b2379f36c2c340e7159a35279b4ecf85.png";